import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://staffeng.com/stories/rebecca-panja"
        }}>{`My Path to Staff Engineering`}</a>
        {
          /*- TODO create a component <Text sx={{ fontSize: [1], fontWeight: `light`, color: `secondary` }}>Oct 2021</Text> -*/
        }
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/how-to-create-great-experiences-and-products-ecfaca084269"
        }}>{`How to Create Great Experiences and Products`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/a-practical-guide-to-your-next-frontend-feature-launch-1a44a443efef"
        }}>{`A practical guide to your next frontend feature launch`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/lessons-from-a-decade-of-work-c04abfe25d65"
        }}>{`What I wish I knew when I started my tech career`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/make-better-decisions-ask-the-right-questions-8db76697b670"
        }}>{`Three Questions to Better Decisions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/best-books-i-read-in-2021-and-highlights-7335fb2754b7"
        }}>{`Best books I read in 2021 and highlights`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/moving-from-canada-to-us-part-2-all-about-finances-tax-residency-and-temporary-housing-ff4346c422e"
        }}>{`Moving from Canada to US, Part 2— Things nobody tells you about preparing to move`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://rebecca.medium.com/all-about-tn-visa-moving-from-canada-to-us-6cbc7005f2d9"
        }}>{`Moving from Canada to US, Part 1— All about TN visa`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      